import { AgentCategory } from "~/shared/enums";
import type { AgentConfig, ValidationFunction } from "~/shared/types";
import { isValidUrlIncludingLocal, validateIsNotEmpty } from "~/utils/validation";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const SERVER_HTTP_IP_URL_REGEX = /^https?:\/\/\d{1,3}(?:\.\d{1,3}){3}(?::\d{1,5})?(?:[/?#].*)?$/;
const isValidServerIpUrl = (value: string) => SERVER_HTTP_IP_URL_REGEX.test(value.trim());

const validateServerUrl: ValidationFunction = (value) =>
  isValidUrlIncludingLocal(value) || isValidServerIpUrl(value)
    ? { isValid: true }
    : { isValid: false, error: "Enter a valid URL" };

const config: AgentConfig = {
  name: "Nanobot",
  category: AgentCategory.ASSISTANT,
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#DE7356",
  description: "Run your own open-source AI agent with full control over the models, data, and hosting",
  descriptionMarkdown: `## Overview

Delegate work to Nanobot directly from Dart. When you assign a task, Dart sends the task prompt to your Nanobot instance and posts the reply back into the task. Later comments on that same task continue the same Nanobot session instead of starting over.

## Setup guide

1. Host Nanobot somewhere Dart can reach
2. Setup [nanobot-channel-openaiapi plugin](https://github.com/HKUDS/nanobot/discussions/3117) and run \`nanobot gateway\`
3. If not open already, open the port in firewall (e.g. run \`sudo ufw allow 18791/tcp\`)
4. Open Dart settings, go to Agents, and choose Nanobot
5. Paste your server URL (e.g. \`http://<your-ip>:18791\`) and enter your API key
6. Assign a task to Nanobot from Dart`,
  configFields: [
    {
      key: "serverUrl",
      type: "text",
      label: "Server URL",
      placeholder: "https://nanobot.example",
      validate: validateServerUrl,
    },
    {
      key: "apiKey",
      type: "password",
      label: "API key",
      placeholder: "Your Nanobot API key",
      validate: validateIsNotEmpty,
    },
  ],
};

export default config;
